var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorLog-container"},[_c('el-divider',{attrs:{"content-position":"left"}},[_vm._v(" 这里会在顶部navbar上模拟一个控制台错误日志 ")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleError}},[_vm._v(" 点击模拟一个chuzhixinjiayou的错误 ")]),(_vm.show)?_c('error-test'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }